import StepKeywords, { validate as vKeywords } from './StepKeywords';
import StepIntent, { validate as vIntent } from './StepIntent';
import StepResearch, { validate as vResearch } from './StepResearch';
import StepDraft, { validate as vDraft } from './StepDraft';
import StepExpert from './StepExpert';
import StepFacts, { validate as vFacts } from './StepFacts';
import StepOriginal from './StepOriginal';
import StepEditing, { validate as vEditing } from './StepEditing';
import StepSeo, { validate as vSeo } from './StepSeo';
import StepJsonLd from './StepJsonLd';
import StepPublish from './StepPublish';

export const STEP_COMPONENTS = {
  keywords: { Component: StepKeywords, validate: vKeywords },
  intent: { Component: StepIntent, validate: vIntent },
  research: { Component: StepResearch, validate: vResearch },
  draft: { Component: StepDraft, validate: vDraft },
  expert: { Component: StepExpert },
  facts: { Component: StepFacts, validate: vFacts },
  original: { Component: StepOriginal },
  editing: { Component: StepEditing, validate: vEditing },
  seo: { Component: StepSeo, validate: vSeo },
  jsonld: { Component: StepJsonLd },
  publish: { Component: StepPublish },
};
